module.exports = __webpack_public_path__ + "src/components/Trust/icons/facebook.png?1d68e6a0";


//////////////////
// WEBPACK FOOTER
// ./src/components/Trust/icons/facebook.png
// module id = 3377
// module chunks = 8